import e from "../../managers/braze-instance.js";
import { destroyFeedHtml as z } from "../../common/feed-display.js";
export function hideContentCards(n) {
  if (!e.rr()) return;
  const o = document.querySelectorAll(".ab-feed");
  for (let e = 0; e < o.length; e++)
    (null == n || (null != n && o[e].parentNode === n)) && z(o[e]);
}
